import Routes from "./routers/routes";
import "./assets/styles/App.scss";
import "@progress/kendo-theme-default/dist/all.css";
import axios from "axios";
import { setBearerToken } from "./helpers/functions";
import { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { io, Socket } from "socket.io-client";
import { notification, Button, message } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import jsonNotification from "./helpers/notification";
import { useSelector, useDispatch } from "react-redux";
import "./App.css";
const baseURL = process.env.REACT_APP_BASE_URL;
// const baseURL = "https://dba0-2405-9800-b820-63eb-e96d-ec09-62fe-14a8.ap.ngrok.io/api/v1" || process.env.REACT_APP_BASE_URL;
const baseURLRoot: String | any = process.env.REACT_APP_BASE_ROOT_URL;
const isProduction = process.env.NODE_ENV === "production" ? true : false;

console.log("BASE_URL =>", baseURL);
console.log("REACT_APP_TEST_VAL =>", process.env.REACT_APP_TEST_VAL);
console.log("isProduction =>", isProduction);

axios.defaults.baseURL = baseURL;

console.log("initial token...");
setBearerToken(axios);
var socketIo: Socket;
function App(props: any) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user, isFetchedUser, socket } = useSelector((state: any) => state);
  const getUser = async () => {
    console.log("get user v1...");

    try {
      const { data }: any = await axios.get(`/auth/me`);
      console.log("data =>", data);
      if (!data) return;

      dispatch({
        type: "UPDATE_USER",
        data: data?.user,
      });

      console.log("set user token...");
      setBearerToken(axios, false, data?.token);
    } catch (err: any) {}

    dispatch({
      type: "IS_FETCH_USER",
      data: true,
    });
  };

  useEffect(() => {
    console.log("test...");

    getUser();
  }, []);

  const socketInitializer: () => void = async () => {
    if (isFetchedUser) {
      const join = [user?.channel, user?._id, 2];

      // for test
      console.log("io baseURLRoot =>", baseURLRoot);

      socketIo = io(baseURLRoot, {
        // path: '/api/dermaster2/v1/socket.io',
        path: "/api/v1/socket.io",
        query: {
          token: localStorage.getItem("token"),
          join,
          data: JSON.stringify(user),
        },
      });
      socketIo.on("connect", () => {
        console.log("connected");
      });

      socketIo.on("disconnect", () => {
        console.log(socketIo.connected); // false
      });
      socketIo.on("notify", (req: any) => {
        jsonNotification(req, history, (json: any) => {
          notification.open(json);
        });
      });
      dispatch({
        type: "SET_SOCKET",
        data: {
          ...socket,
          io: socketIo,
        },
      });
    }
  };
  useEffect(() => socketInitializer(), [isFetchedUser]);
  return <Routes />;
}
export default App;
